import { UserManagerSettings } from 'oidc-client-ts';

// OIDC Configuration for Lex SSO
export const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY || 'https://homolog-api.lex.education/sso',
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID || 'd022c05b-5a4f-4f8c-85c3-e932d4ece993',
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI || `${window.location.origin}/school`,
  post_logout_redirect_uri: import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  response_type: 'code',
  scope: 'openid profile lex-account lex-account-user.read',
  automaticSilentRenew: true,
  silent_redirect_uri: import.meta.env.VITE_OIDC_SILENT_REDIRECT_URI || `${window.location.origin}/silent-callback.html`,
  loadUserInfo: true,
  filterProtocolClaims: true,
  monitorSession: true,
  // Configurações para evitar preflight CORS
  fetchRequestCredentials: 'omit',
};
